<template>
  <!--<a-locale-provider :locale="locale">-->
  <a-config-provider  :locale="locale">
  <div style="">
      <router-view></router-view>
  </div>
  </a-config-provider>
  <!--</a-locale-provider>-->
</template>
<script>
  import user from  './view/userManage/user.vue'
  import shop from  './view/shop/shop.vue'
  import staff from  './view/staff/staff.vue'
  import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'
  export default {
    data() {
      return {
        locale: zhCN,
        collapsed: false,
        key: 1
      }
    },
    components: {
      'user': user,
      'shop': shop,
      'staff': staff

    },
    watch: {
      collapsed(val) {
        console.log('collapsed', val)
      }
    },
    methods: {
      onCollapse(collapsed, type) {
        console.log(collapsed, type)
      },
      onBreakpoint(broken) {
        console.log(broken)
      },
      change (e) {
        console.log(e.key)
        this.key = e.key
      }
    }
  }
</script>
<style>
  #components-layout-demo-custom-trigger .trigger {
    font-size: 18px;
    line-height: 64px;
    padding: 0 24px;
    cursor: pointer;
    transition: color 0.3s;
  }

  #components-layout-demo-custom-trigger .trigger:hover {
    color: #1890ff;
  }

  #components-layout-demo-custom-trigger .logo {
    height: 32px;
    background: rgba(255, 255, 255, 0.2);
    margin: 16px;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue